import * as Yup from "yup";

export const deviceOonfigurationValidationSchema = Yup.object({
  hf: Yup.string().required("HF is required"),
  modelName: Yup.string().required("Model name is required"),
  deviceTypeId: Yup.string().required("Device type is required"),
  manufacturerId: Yup.string().required("Manufacturer is required"),
});
